import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative flex md:flex-row flex-col h-full justify-center bg-blue-button" }
const _hoisted_2 = {
  key: "landing-main",
  class: "flex flex-col items-center h-full justify-end pb-12"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Log in with PIN ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Opplæring ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Test User 1 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Test User 2 ")
const _hoisted_7 = {
  key: "landing-mobil",
  class: "flex flex-col items-center h-full justify-center pb-12"
}
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("feide login ")
const _hoisted_10 = {
  key: "landing-otc",
  class: "flex flex-col items-center h-full justify-center pb-12"
}
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = {
  key: "landing-pin-user",
  class: "flex flex-col items-center h-full justify-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "Log in as", -1 /* HOISTED */)
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-xs" }
const _hoisted_16 = {
  key: "landing-pin-pin",
  class: "flex flex-col items-center h-full justify-center"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "What's your PIN code?", -1 /* HOISTED */)
const _hoisted_18 = { class: "absolute top-0 left-0 p-4 text-center text-white w-full" }
const _hoisted_19 = { class: "absolute bottom-0 right-0 text-xs m-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlButton = _resolveComponent("SlButton")!
  const _component_AnswerInput = _resolveComponent("AnswerInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      mode: "out-in",
      name: "fade"
    }, {
      default: _withCtx(() => [
        (_ctx.mode === 'login')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.filteredLocalUsersWithExpiry.length > 0)
                ? (_openBlock(), _createBlock(_component_SlButton, {
                    key: 0,
                    id: "button-pinlogin",
                    class: "my-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.PINlogin()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_SlButton, {
                class: "my-2",
                "background-class": "bg-green-highlight",
                "background-colour": 'bg-green-highlight',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DPlogin()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('openidLoginButton')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              (_ctx.showLearningLogin)
                ? (_openBlock(), _createBlock(_component_SlButton, {
                    key: 1,
                    id: "button-testuser",
                    class: "my-2",
                    "background-class": "bg-white",
                    "text-class": "text-black",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.DPlogin(true, 'Opplæring')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.showTestLogin)
                ? (_openBlock(), _createBlock(_component_SlButton, {
                    key: 2,
                    id: "button-testuser",
                    class: "my-2",
                    "background-class": "bg-white",
                    "text-class": "text-black",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DPlogin(true, 'testuser1')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.showTestLogin)
                ? (_openBlock(), _createBlock(_component_SlButton, {
                    key: 3,
                    id: "button-testuser2",
                    class: "my-2",
                    "background-class": "bg-white",
                    "text-class": "text-black",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.DPlogin(true, 'testuser2')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode("WebAudioTest /"),
              _createCommentVNode(" <SlButton\n          class=\"mb-24 focus:outline-none bg-green-500 text-white justify-self-end\"\n          :customWidth=\"'12rem'\"\n          @click=\"login()\"\n          >Log in Skip ID Porten\n        </SlButton> ")
            ]))
          : (_ctx.mode === 'smsLogin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_AnswerInput, {
                    modelValue: _ctx.mobileNumber,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mobileNumber) = $event)),
                    valid: _ctx.validators.mobil,
                    "onUpdate:valid": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.validators.mobil) = $event)),
                    class: "m-2",
                    mode: "tel",
                    label: _ctx.t('enterMobilNumber'),
                    border: true,
                    onEnterkey: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sendPhoneNumber()))
                  }, null, 8 /* PROPS */, ["modelValue", "valid", "label"]),
                  _createVNode(_component_SlButton, {
                    id: "button-send",
                    class: "mt-10 capitalize",
                    "background-class": "bg-green-highlight",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sendPhoneNumber()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('send')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_SlButton, {
                    id: "button-admin",
                    class: "my-2 capitalize",
                    "background-class": "bg-grey",
                    "text-class": "text-black",
                    onClick: _cache[9] || (_cache[9] = () => (_ctx.mode = 'login'))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
            : (_ctx.mode === 'smsCode')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_AnswerInput, {
                      valid: _ctx.validators.mobil,
                      "onUpdate:valid": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.validators.mobil) = $event)),
                      modelValue: _ctx.otc,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.otc) = $event)),
                      class: "m-2",
                      mode: "text",
                      label: _ctx.t('enterMobilOTC'),
                      border: true,
                      onEnterkey: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendOTC()))
                    }, null, 8 /* PROPS */, ["valid", "modelValue", "label"]),
                    _createVNode(_component_SlButton, {
                      id: "button-send",
                      class: "mt-16",
                      "background-class": "bg-green-highlight",
                      onClick: _ctx.sendOTC
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('send')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_SlButton, {
                      id: "button-back",
                      class: "my-2",
                      "background-class": "bg-grey",
                      "text-class": "text-black",
                      onClick: _cache[13] || (_cache[13] = () => ((_ctx.pinCode = ''), (_ctx.otc = ''), (_ctx.mode = 'smsLogin')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('back')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]))
              : (_ctx.mode === 'pin-user')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLocalUsersWithExpiry, (u) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: u._id,
                        class: "mt-8 rounded-full w-full bg-white flex flex-col items-center p-4",
                        onClick: ($event: any) => (_ctx.selectUser(u))
                      }, [
                        _createElementVNode("p", null, _toDisplayString(u.name), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_15, "Expires in " + _toDisplayString(u.expiresIn.value), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : (_ctx.mode === 'pp')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_AnswerInput, {
                        modelValue: _ctx.pinCode,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pinCode) = $event)),
                        mode: "text",
                        class: "mt-8"
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      _createVNode(_component_SlButton, {
                        text: "login",
                        class: "mt-8 focus:outline-none",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.localUserLogin()))
                      })
                    ]))
                  : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_Transition, {
      mode: "out-in",
      name: "fade"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", null, _toDisplayString(_ctx.message), 1 /* TEXT */)
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("p", _hoisted_19, "v" + _toDisplayString(_ctx.appVersion), 1 /* TEXT */)
  ]))
}